import "./gallery.css";

import {basicGalleryModal} from "./templates/gallery-modal.js";
import {galleryPictureElement} from "./templates/picture-template.js";
import {galleryModalBanner} from "./templates/gallery-rect-banner.js";

const galleriesData = [];


globalThis.initGalleryData = async function(gallDataUrl) {
   if ($('.site-wrapper').hasClass('articles')) {
        try {
            // Access the global `gallDataUrl` variable set by PHP
            const galleryDataUrl = gallDataUrl;

            // Fetch the JSON data from the URL
            const response = await fetch(galleryDataUrl);

            if (!response.ok) {
                throw new Error(`Failed to fetch data: ${response.statusText}`);
            }

            // Parse the JSON response
            const data = await response.json();
            console.log('Gallery items count:', data.length, 'Fetched Data:', data);

            // Use the data in your component
            if (data.length > 0) {
                for (let i = 0; i < data.length; i++) {
                    if ( !sessionStorage.getItem(data[i].gallery_info.id) ) {
                        sessionStorage.setItem( data[i].gallery_info.id, 0 );
                    };
                    console.log('sessionStorage ------', data[i].gallery_info.id, sessionStorage.getItem(data[i].gallery_info.id) );
                    console.log('Gallery i', i );
                    galleriesData.push(data[i]);
                    $('body').append(dialogComponentInitial(data[i], i, sessionStorage.getItem(data[i].gallery_info.id) ) );
                    console.log('Gallery data-order (i)', i, ' pics total ', data[i].gallery_info.pics_total, 'Current pic:', sessionStorage.getItem(data[i].gallery_info.id));
                    if (sessionStorage.getItem(data[i].gallery_info.id) == 0){
                        $('#' + data[i].gallery_info.id + ' .click-area-back').addClass('endposition');
                    } else if (sessionStorage.getItem(data[i].gallery_info.id) == data[i].gallery_info.pics_total - 1 ) {
                        $('#' + data[i].gallery_info.id + ' .click-area-next').addClass('endposition');
                    }
                }
            }

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
};


//Create Dialog Element
function dialogComponentInitial(galleryData, dataOrder, initialItem = 0){
    console.log('Gallery data: ',galleryData);
    
    let galleryId = galleryData['gallery_info'].id;
    let galleryPicsCount = galleryData['gallery_info'].pics_total;
    //let gallerySource = galleryData['gallery_info'].gallery_source;
    let initialItemNum = parseInt(initialItem) + 1;
    let currentItemType = galleryData['item_' + initialItem].item_type;
    let imgMax = galleryData['item_' + initialItem].img_src_max;
    let imgMobile = galleryData['item_' + initialItem].img_src_mobile;
    let embedHtml = galleryData['item_' + initialItem].embedHtml;
    let currentItemTitile = galleryData['item_' + initialItem].item_title;
    let currentPictureElement = displayedItemHtml(currentItemType, imgMax, imgMobile, embedHtml);

    let dialogWrapperElement = basicGalleryModal(galleryId, dataOrder, galleryPicsCount, initialItemNum, currentPictureElement, currentItemTitile);
    $('.gallery[data-id="'+ galleryId +'"]').attr('data-order', dataOrder);
    return dialogWrapperElement;    
}

//Display the Picture / Instagram embed
function displayedItemHtml(type, imgMax = '', imgMob = '', embedHtml = ''){
    let itemHtml;
    if (type == 'img'){
        itemHtml = galleryPictureElement(imgMax, imgMob);
    } else if (type == 'social'){    
        itemHtml = embedHtml;
        // Load Instagram script dynamically if needed, then process embeds
        loadInstagramEmbedScript(() => {
            if (window.instgrm) {
                window.instgrm.Embeds.process();
            }
        });
    }
    return itemHtml;
}

function loadInstagramEmbedScript(callback) {
    if (!document.querySelector('script[src="https://www.instagram.com/embed.js"]')) {
        const script = document.createElement('script');
        script.src = "https://www.instagram.com/embed.js";
        script.async = true;
        script.onload = callback; // Ensure script is loaded before processing embeds
        document.body.appendChild(script);
    } else {
        callback(); // If already loaded, just execute the callback
    }
}

function updatePicture(galleryId, displayedPictureHtml, newItemNumber, newTitle){
    let pictureWrapperElement = $('#' + galleryId + ' .gallery-picture');
    let newNumberElement = $('#' + galleryId + ' .current-pic');
    let titleElement = $('#' + galleryId + ' .pic-title');
    
    pictureWrapperElement.html(displayedPictureHtml);
    newNumberElement.html(newItemNumber + 1); // in the .current-pic element, the value of the number is 1-based
    titleElement.html(newTitle);
    
    loadInstagramEmbedScript(() => {
        if (window.instgrm) {
            window.instgrm.Embeds.process();
        }
    });
    
    //should refresh banner, does not work
//    let bannerWrapperElement = $('#' + galleryId + ' .banner.position-atf');
//    bannerWrapperElement.html(galleryModalBanner);
    
    //url change and update history
    updateUrl(galleryId, newItemNumber);    
    //updates current picture for this gallery (push in session storage)
    sessionStorage.setItem( galleryId, newItemNumber );
}

//url change and push new entry to history
function updateUrl(galleryId, newItemNumber){
    //newItemNumber is 0-based
    let data = galleriesData[$('#' + galleryId).attr('data-order')];
    let newItem_id = data['item_' + newItemNumber].item_id;
    let state = { gallery_id: galleryId, pic_id: newItem_id};    
	let url = data['item_' + newItemNumber].item_url;
    history.pushState(state, '', url);	
}

//click event arrows functionality
$('body').on('click', '.gallery-modal .click-area-back:not(.endposition), .gallery-modal .click-area-next:not(.endposition)', function (e) {
    e.preventDefault();
    e.stopPropagation();
    console.log('Gallery arrow clicked');
     //check for full screen gallery ID
    if ( !$('.gallery-modal.full-screen-gallery').attr('id') ){
        $('.gallery-modal.full-screen-gallery').attr('id', galleriesData[0].gallery_info.id); //adds id to a full screen gallery        
    }    
    
    let galleryId = $(this).closest('.gallery-modal').attr('id');
    console.log('Gallery arr click, INITIAL .current-pic number value', parseInt( $('#' + galleryId).find('.current-pic').html() ));
    let currentPosition = parseInt( $('#' + galleryId).find('.current-pic').html() ) - 1; // 0-BASED order in Json
    console.log('Gallery arr click, currentPosition = ', currentPosition);
    let nextPosition;// 0-BASED order in Json
    let dataOrder = $('#' + galleryId).attr('data-order');
    let data = galleriesData[dataOrder];
    let picsCount = data['gallery_info'].pics_total;
    
    if ($(this).hasClass('click-area-next')) {
        $(this).siblings('.click-area-back').removeClass('endposition');
        nextPosition = currentPosition + 1;         
    } else if ($(this).hasClass('click-area-back')) {
        $(this).siblings('.click-area-next').removeClass('endposition');
        nextPosition = currentPosition - 1; 
    }
    
    if (nextPosition == 0) {
        $(this).addClass('endposition');
    }
    if (nextPosition == (picsCount - 1) ) {
        $(this).addClass('endposition');
    }
        
    let newItemType = data['item_' + nextPosition].item_type;
    let newItemMax = data['item_' + nextPosition].img_src_max;
    let newItemMob = data['item_' + nextPosition].img_src_mobile;
    let newItemEmbedHtml = data['item_' + nextPosition].embedHtml;
    
    let displayedPictureHtml = displayedItemHtml(newItemType, newItemMax, newItemMob, newItemEmbedHtml);
        
    let newTitle = data['item_' + nextPosition].item_title;   
    
    console.log('Gallery arr click, nextPosition = ', nextPosition);
    
    updatePicture(galleryId, displayedPictureHtml, nextPosition, newTitle);
    
});





$('body').on('click', '.gallery.card', function (e) {
    // unhide modal
    e.preventDefault();
    e.stopPropagation();
    $('#'+ $(this).attr('data-id'))[0].showModal();
    
    let galleryId = galleriesData[$(this).attr('data-order')].gallery_info.id;
    
    console.log('Gallery open initialItemNum', sessionStorage.getItem( galleriesData[$(this).attr('data-order')].gallery_info.id ), 
    "galleriesData[$(this).attr('data-order')]", galleriesData[$(this).attr('data-order')],
    "galleryId = ", galleryId);
    
    let initialItemNum = sessionStorage.getItem(galleriesData[$(this).attr('data-order')].gallery_info.id);
    //url change and update history, initialItemNum - 0-based
    updateUrl(galleryId, initialItemNum);
    
});

$('body').on('click', '.gallery-modal .close-button', function (e) {
   // hide modal
   $(this).closest('.gallery-modal')[0].close();
});




//console.log('gallery working=====================================================');
